var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// hide the div based on dataId and actionDiv
export const setDivtoHide = (dataId, actionDiv, targetAction) => {
    const targetDivHistory = document.querySelectorAll(`[data-id="${dataId}-${actionDiv}"]`);
    targetDivHistory.forEach((parentDivs) => {
        if (parentDivs.classList.contains(targetAction)) {
            parentDivs.classList.remove(targetAction);
        }
    });
};
//add class to div
export const addClasstoDiv = (dataId, actionDiv, targetAction) => {
    const targetDivHistory = document.querySelectorAll(`[data-id="${dataId}-${actionDiv}"]`);
    targetDivHistory.forEach((parentDivs) => {
        if (!parentDivs.classList.contains(targetAction)) {
            parentDivs.classList.add(targetAction);
        }
    });
};
//remove class to div
export const removeClassfromDiv = (dataId, actionDiv, targetAction) => {
    const targetDivHistory = document.querySelectorAll(`[data-id="${dataId}-${actionDiv}"]`);
    targetDivHistory.forEach((parentDivs) => {
        if (parentDivs.classList.contains(targetAction)) {
            parentDivs.classList.remove(targetAction);
        }
    });
};
// Validate if a string is a valid HTTP/HTTPS URL
export const isValidUrl = (url) => {
    return /^https?:\/\/.+/.test(url);
};
// Fetch presigned URL for S3 objects
export const getPresignedUrl = (uri, baseUrl, authToken) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `${baseUrl}/geturl?path=${encodeURIComponent(uri)}`;
    if (authToken)
        url += `&token=${encodeURIComponent(authToken)}`;
    try {
        const res = yield fetch(url, { credentials: 'include' });
        let presignedUrl = yield res.text();
        if (presignedUrl) {
            presignedUrl = presignedUrl.trim().replace(/^["']|["']$/g, '');
            return presignedUrl;
        }
        return null;
    }
    catch (err) {
        console.error('Error fetching presigned URL:', err);
        return null;
    }
});
